import { GridProduct } from "hub/src/components/store/ProductGrid";

export const getLowestPrice = (product: GridProduct, tags: string[]) => {
  if (Object.keys(product?.pricing ?? {}).length > 0) {
    let lowestPrice = product.price;
    tags.forEach((tag) => {
      if (product.pricing && product.pricing[tag] !== undefined) {
        lowestPrice = Math.min(lowestPrice, product.pricing[tag]);
      }
    });
    return lowestPrice;
  }
  return product.price;
};
